<template>
  <Card
    :loading="loading"
    class="pt-4 px-4 relative table-chart"
  >
    <div class="flex items-center border-b-2 border-black pb-3">
      <SelectControl
        class="mr-3"
        :options="groupableBy"
        :value="groupBy"
        :disabled="loading"
        @input="handleGroupByChanged"
      />
      <div class="font-normal flex-1">
        <slot></slot>
      </div>
      <ExportTable
        :disabled="loading"
        @export="$emit('export', arguments[0])"
      />
    </div>

    <div v-if="loading" class="flex items-center justify-center" style="height:200px;">
      <Loader class="text-60" />
    </div>
    <template v-else>
      <table
        v-if="data && data.length > 0"
        class="table w-full"
        cellpadding="0"
        cellspacing="0"
      >
        <tbody>
        <tr
          v-for="(row, index) in data"
          :key="index"
          class="cursor-pointer"
          :data="row"
          @click="$emit('rowClick', row)">
          <td>{{ row.label }}</td>
          <td class="text-right">{{ $n(row.value, format) }}</td>
        </tr>
        </tbody>
      </table>
      <NoMatches v-else />

    </template>

  </Card>
</template>

<script>
  import Card from '@/_legacy/components/Card.vue';
  import Loader from '@/_legacy/components/Icons/Loader.vue';
  import SelectControl from '@/_legacy/components/Controls/SelectControl.vue';
  import ExportTable from '@/_legacy/views/Analytics/components/ExportTable.vue';
  import NoMatches from '@/_legacy/views/Analytics/components/NoMatches.vue';

  export default {
    components: {
      Card,
      SelectControl,
      Loader,
      ExportTable,
      NoMatches,
    },

    props: {
      data: {
        type: Array,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      groupableBy: {
        type: Array,
        required: true,
      },
      groupBy: {
        type: String,
        required: true,
      },
      format: {
        type: String,
        default: 'analyticsInteger',
      },
    },

    methods: {
      handleGroupByChanged(value) {
        this.$emit('groupByChanged', value);
      },
    },
  };
</script>
